// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var FilterList = /** @class */ (function () {
    function FilterList(parent, trackers, toggleCb) {
        var _this = this;
        this.children = [];
        this.getCurrentFilter = function () {
            return _this.filterList;
        };
        var _self = this;
        var active = false;
        trackers = trackers.concat("other");
        _self.filterList = [];
        _self.el = document.createElement("div");
        _self.el.className = "filterlist";
        var inputEl = document.createElement("div");
        inputEl.className = "filterlist-input";
        inputEl.innerText = "filter nodes...";
        _self.el.appendChild(inputEl);
        var dropdownMenuEl = document.createElement("div");
        dropdownMenuEl.className = "filterlist-dropdown";
        _self.el.appendChild(dropdownMenuEl);
        dropdownMenuEl.onkeyup = function (evt) {
            if (active && evt.keyCode === 27) {
                evt.stopPropagation();
                _hideDropdown();
            }
        };
        var _loop_1 = function (t) {
            var chEl = document.createElement("div");
            chEl.setAttribute("tabindex", "0");
            chEl.setAttribute("filter-type", t);
            chEl.className = "filterlist-toggle";
            var checkbox = document.createElement("div");
            checkbox.className = "checkbox on";
            var label = document.createElement("span");
            label.className = "label";
            label.innerText = t;
            chEl.appendChild(checkbox);
            chEl.appendChild(label);
            chEl.onkeyup = function (evt) {
                if (active && evt.keyCode === 27) {
                    evt.stopPropagation();
                    _hideDropdown();
                }
            };
            chEl.onclick = function (evt) {
                evt.stopPropagation();
                chEl.focus();
                if (checkbox.className === "checkbox off") {
                    if (evt.shiftKey) {
                        _self.filterList = trackers.concat();
                        for (var _i = 0, _a = _self.children; _i < _a.length; _i++) {
                            var ch = _a[_i];
                            ch.childNodes[0].className = "checkbox off";
                        }
                    }
                    _self.filterList.splice(_self.filterList.indexOf(t), 1);
                    checkbox.className = "checkbox on";
                }
                else {
                    if (evt.shiftKey) {
                        _self.filterList = [];
                        for (var _b = 0, _c = _self.children; _b < _c.length; _b++) {
                            var ch = _c[_b];
                            ch.childNodes[0].className = "checkbox on";
                        }
                    }
                    _self.filterList.push(t);
                    checkbox.className = "checkbox off";
                }
                toggleCb();
            };
            _self.children.push(chEl);
        };
        for (var _i = 0, trackers_1 = trackers; _i < trackers_1.length; _i++) {
            var t = trackers_1[_i];
            _loop_1(t);
        }
        function _hideDropdown() {
            active = false;
            for (var _i = 0, _a = _self.children; _i < _a.length; _i++) {
                var ch = _a[_i];
                dropdownMenuEl.removeChild(ch);
            }
        }
        function _showDropdown() {
            active = true;
            for (var _i = 0, _a = _self.children; _i < _a.length; _i++) {
                var ch = _a[_i];
                dropdownMenuEl.appendChild(ch);
            }
            dropdownMenuEl.focus();
        }
        _self.el.onkeyup = function (evt) {
            if (active && evt.keyCode === 27) {
                evt.stopPropagation();
                _hideDropdown();
            }
        };
        _self.el.onclick = function () {
            if (!active) {
                _showDropdown();
            }
            else {
                _hideDropdown();
            }
        };
        parent.appendChild(_self.el);
    }
    return FilterList;
}());
export { FilterList };
//# sourceMappingURL=filterList.js.map